module.exports = __webpack_public_path__ + "static/media/news7.d9565374.png";